import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Stack,
  Paper,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { ENDPOINT, IMAGE_BASE_URL } from "../../../endpoints/endpoints";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HighLightCategoryUpdate = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: "",
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // ============================================
  // Fetch highlightcategory Detail
  // ============================================
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      toast.warning("Please log in first!");
      navigate("/login");
      return;
    }

    const fetchhighlightcategory = async () => {
      try {
        const res = await axios.get(ENDPOINT.HIGHLIGHTCATEGORY_DETAIL(id), {
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = res.data.data; // ✔ correct backend key

        setFormData({
          name: data.name,
        });
      } catch (err) {
        console.error(err);
        toast.error("Failed to load highlightcategory");
      } finally {
        setLoading(false);
      }
    };

    fetchhighlightcategory();
  }, [id, navigate]);

  // ============================================
  // Input Handler
  // ============================================
  const handleChange = (e) => {
    setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  // ============================================
  // UPDATE Submit
  // ============================================
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const token = localStorage.getItem("accessToken");

      const data = new FormData();
      data.append("name", formData.name);

      const res = await axios.put(ENDPOINT.HIGHLIGHTCATEGORY_UPDATE(id), data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      toast.success("highlightcategory updated successfully");

      setTimeout(() => navigate(`/highlightcategory/${id}`), 1200);
    } catch (err) {
      console.error(err);
      toast.error("Failed to update highlightcategory");
    } finally {
      setSaving(false);
    }
  };

  // ============================================
  // LOADING Spinner
  // ============================================
  if (loading) {
    return (
      <Box display="flex" height="80vh" justifyContent="center" alignItems="center">
        <CircularProgress />
      </Box>
    );
  }

  // ============================================
  // UI
  // ============================================
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
      <ToastContainer />

      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight={600} mb={3}>
          ✏️ Update HighLight Category
        </Typography>

        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            {/* Name */}
            <TextField
              label="highlightcategory Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            {/* BUTTONS */}
            <Stack direction="row" justifyContent="space-between">
              <Button variant="outlined" onClick={() => navigate(`/highlightcategory/${id}`)}>
                Cancel
              </Button>

              <Button
                type="submit"
                variant="contained"
                color="success"
                disabled={saving}
                sx={{ px: 4 }}
              >
                {saving ? <CircularProgress size={24} /> : "Update highlightcategory"}
              </Button>
            </Stack>
          </Stack>
        </form>
      </Paper>
    </Container>
  );
};

export default HighLightCategoryUpdate;
